// src/components/ProtectedRoute.js
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Auth } from '../utils/Auth';
import LoadingPage from '../pages/Loading';
import { config } from '../config/host';

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const result = await Auth.isAuthenticated();
      setAuthenticated(result);
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <LoadingPage />
    );
  }

  if (!authenticated) {
    return <Navigate to={`${config.subPath}/login`} replace />;
  }

  return children;
};

export default ProtectedRoute;
